import { render, staticRenderFns } from "./reminderSetting.vue?vue&type=template&id=220962fc&scoped=true"
import script from "./reminderSetting.vue?vue&type=script&lang=js"
export * from "./reminderSetting.vue?vue&type=script&lang=js"
import style1 from "./reminderSetting.vue?vue&type=style&index=1&id=220962fc&prod&lang=scss&scoped=true"
import style2 from "./reminderSetting.vue?vue&type=style&index=2&id=220962fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220962fc",
  null
  
)

export default component.exports